/**
 * Human-friendly operator label.
 * OpenChargeMap's crowdsourced data uses the placeholder "(Unknown Operator)"
 * (operator ID 1) when a submitter didn't pick an operator — show these as
 * "Independent Operator" instead of the raw placeholder.
 */
export function operatorLabel(operator: string): string {
  if (!operator || operator.toLowerCase().includes('unknown')) {
    return 'Independent Operator'
  }
  return operator
}
